import { h } from '@stencil/core';
export class RelatedProductsDialog {
  constructor() {
    this.isOpen = undefined;
    this.products = [];
    this.header = undefined;
    this.secondaryCTALabels = undefined;
    this.cartTransferEnabled = undefined;
    this.myProducts = undefined;
    this.groupId = undefined;
    this.productId = undefined;
    this.apcCta = undefined;
    this.onProductClick = undefined;
    this.productAvailabilityInfo = undefined;
    this.localeCode = undefined;
    this.isExternalConsumer = undefined;
    this.productRelationCustomConfig = undefined;
    this.ctaInfo = undefined;
  }
  didPricesLoad(event) {
    if (event.detail) {
      this.productAvailabilityInfo = event.detail;
    }
  }
  render() {
    return (h("se-dialog", { open: this.isOpen, size: "xlarge" }, h("se-dialog-header", { "close-icon": true }, this.header), h("se-dialog-content", { option: "fill" }, h("div", { class: "related-product-dialog" }, this.products.map((product) => (h("pes-related-product-card", { class: "related-product-dialog__card", secondaryCTALabels: this.secondaryCTALabels, product: product, cartTransferEnabled: this.cartTransferEnabled, myProducts: this.myProducts, groupId: this.groupId, productId: this.productId, onProductClick: this.onProductClick, key: product.product.skuId, productAvailabilityInfo: this.productAvailabilityInfo, apcCta: this.apcCta, isExternalConsumer: this.isExternalConsumer, productRelationCustomConfig: this.productRelationCustomConfig, ctaInfo: this.ctaInfo })))))));
  }
  static get is() { return "pes-related-products-dialog"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["dialog.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["dialog.css"]
    };
  }
  static get properties() {
    return {
      "isOpen": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines if the modal is open or not"
        },
        "attribute": "is-open",
        "reflect": false
      },
      "products": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "RelatedProduct[]",
          "resolved": "RelatedProduct[]",
          "references": {
            "RelatedProduct": {
              "location": "import",
              "path": "../../../../generated/graphql"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of products to render in the modal"
        },
        "defaultValue": "[]"
      },
      "header": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines header of the modal"
        },
        "attribute": "header",
        "reflect": false
      },
      "secondaryCTALabels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSecondaryCTALabels",
          "resolved": "{ addToCartLabel?: string; addToFavoritesLabel?: string; removeFromFavoritesLabel?: string; }",
          "references": {
            "TSecondaryCTALabels": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines a set of labels to be used as a fallback in case `productCtas` property doesn't have labels defined"
        }
      },
      "cartTransferEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines which CTA button should be shown: \"Add to Cart\" or \"Add to My Products/Remove from My Products\".\n Used only if there are no CTA settings given by a consumer."
        },
        "attribute": "cart-transfer-enabled",
        "reflect": false
      },
      "myProducts": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductGroup[] | null",
          "resolved": "TProductGroup[]",
          "references": {
            "TProductGroup": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "List of products and groups that are in the My Products"
        }
      },
      "groupId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "group-id",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "onProductClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(productRef: string) => void",
          "resolved": "(productRef: string) => void",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "productRelationCustomConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRelatedProductCustomConfig",
          "resolved": "{ showBothProductCtasButton?: boolean; productCtasButtonConfig?: { addToFavoritesLabel?: string; removeFromFavoritesLabel?: string; }; showQuantityColumn?: boolean; quantityColumnConfig?: { label?: string; valueKey?: string; }; }",
          "references": {
            "TRelatedProductCustomConfig": {
              "location": "import",
              "path": "../../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.TCtaInfo",
          "resolved": "{ [key: string]: { type: string; label?: string; primary?: boolean; url?: string; gaAttributes?: TGaAttributes; }; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get listeners() {
    return [{
        "name": "onLoadPrices",
        "method": "didPricesLoad",
        "target": "document",
        "capture": false,
        "passive": false
      }];
  }
}
